<template>
  <Popover class="relative h-[48px] flex items-center" v-slot="{ open }">
    <PopoverButton
      :class="[
        open
          ? 'text-gray-900 dark:text-white px-4 h-[48px]'
          : 'text-tolopea dark:text-white h-[48px] px-6 ',
        'group bg-[#e4e6ec] border-[#cdcdcd] dark:border-[#292929] dark:bg-[#171717] rounded-md inline-flex justify-start items-center text-base font-medium hover:text-gray-900 dark:hover:text-gold focus:outline-none',
      ]"
    >
      <span>
        {{ selected.name }}
      </span>
      <ChevronRightIcon
        :class="[
          open
            ? 'text-tolopea dark:text-white'
            : 'text-tolopea dark:text-white',
          'ml-2 h-5 w-5 group-hover:text-tolopea dark:group-hover:text-gold',
        ]"
        aria-hidden="true"
      />
    </PopoverButton>

    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="translate-y-1 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-1 opacity-0"
    >
      <PopoverPanel
        class="absolute rounded-md border-[2px] dark:border-[#2e3038] bg-gradient-to-br from-[#fafafa] via-[#f8f8f8] to-[#f4f4f4] dark:from-[#201f29] dark:via-[#21202a] dark:to-[#2a2932] z-10 left-1/2 transform -translate-x-1/2 mt-3 px-2 w-screen max-w-xs sm:px-0"
      >
        <div class="overflow-hidden px-[2px] py-[2px]">
          <div class="relative grid gap-6 px-5 py-6 sm:gap-6 sm:p-6">
            <a
              v-for="item in languages"
              :key="item.id"
              :href="item.href"
              class="flex flex-row items-center justify-between p-3 -m-3 text-gray-900 transition duration-150 ease-in-out rounded-md dark:text-white hover:dark:text-gold"
            >
              <p class="text-base font-medium">
                {{ item.name }}
              </p>
              <span v-if="item.code === current"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13.551"
                  height="10.478"
                  viewBox="0 0 13.551 10.478"
                >
                  <path
                    id="Path_1273"
                    data-name="Path 1273"
                    d="M22689.438,7206.515l3.871,2.892,6.871-8.068"
                    transform="translate(-22688.039 -7199.929)"
                    fill="none"
                    stroke="#eecb8c"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                </svg>
              </span>
            </a>
          </div>
        </div>
      </PopoverPanel>
    </transition>
  </Popover>
</template>

<script>
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/vue/solid";
import { ref } from "vue";

const languages = [
  { id: 1, name: "English", href: "/lang/en", current: true, code: "en" },
  { id: 2, name: "Française", href: "/lang/fr", current: false, code: "fr" },
];

export default {
  components: {
    Popover,
    PopoverButton,
    PopoverPanel,
    ChevronRightIcon,
    ChevronDownIcon,
  },
  props: {
    current: {
      type: String,
      default: "en",
      validator(value) {
        return ["en", "fr"].includes(value);
      },
    },
  },
  setup(props) {
    const current = ref(props.current);
    const selected = ref(
      languages.filter((lang) => lang.code === current.value)[0]
    );
    return {
      selected,
      languages,
    };
  },
};
</script>
